import { cn } from '@/shared/utils'

interface PillOption {
  value: string
  label: string
}

interface PillSelectorProps {
  options: PillOption[]
  value: string | string[]
  onChange: (value: string | string[]) => void
  multiple?: boolean
  className?: string
}

export function PillSelector({ options, value, onChange, multiple = false, className }: PillSelectorProps) {
  const selectedValues = Array.isArray(value) ? value : [value]

  const handleSelect = (optionValue: string) => {
    if (multiple) {
      const newValues = selectedValues.includes(optionValue)
        ? selectedValues.filter((v) => v !== optionValue)
        : [...selectedValues, optionValue]
      onChange(newValues)
    } else {
      onChange(optionValue)
    }
  }

  return (
    <div className={cn('flex flex-wrap gap-2', className)}>
      {options.map((option) => {
        const isSelected = selectedValues.includes(option.value)
        return (
          <button
            key={option.value}
            type="button"
            onClick={() => handleSelect(option.value)}
            className={cn('pill-selector', isSelected ? 'pill-selector-active' : 'pill-selector-inactive')}
          >
            {option.label}
          </button>
        )
      })}
    </div>
  )
}
